module.exports = __webpack_public_path__ + "img/0-sm.145f45fb.jpg";